import { gql } from '$lib/apollo';

export const GET_IRK_SESSION = gql`
  query GetIrkSession {
    currentSession {
      id
      name
      slug
      roles
      timezone
      unverified
      isOnline
      intercomToken
      requestCountry
      unreadNotificationCount
      unseenNotificationCount
      unreadMessageCount
      features
      totalBalance
      isTeamCommunity
      groupTeamMemberships(first: 1, states: [REQUESTED]) {
        totalCount
        edges {
          node {
            id
            group {
              id
              title
            }
          }
        }
      }
      settings {
        feedIcebreakerDismissed
        contestBannerDismissed
        guideLaunchBannerDismissed
      }
      blockLayout {
        id
      }
      discord {
        id
        hasLatestPermissions
      }
      faqs {
        id
      }
      faqCover {
        original {
          url
          width
          height
        }
      }
      followingGamesCount
      follows(type: GAME, first: 1) {
        edges {
          node {
            id
            game {
              id
              slug
            }
          }
        }
      }
      avatar {
        original {
          url
          width
          height
        }
      }
      cover {
        original {
          url
          width
          height
        }
      }
      bio
      currentLevel
      currentLevelXp
      currentLevelXpRequired
      xpRequiredToLevel
      totalExperience
      email
      metafyPartner
      metafyPartnerType
      metafyPartnerReferralIdentifier
      metafyPartnerSubscription {
        id
        state
        expiresAt
        trialStartedAt
        trialEndsAt
        currentTermStartedAt
        currentTermEndsAt
        currentPeriodStartedAt
        currentPeriodEndsAt
        product {
          id
          name
          price
          billingFrequency
        }
        order {
          id
          items {
            id
          }
        }
      }
      useCreditForMetafyPro
      hasBillingInfo
      productCoachingCount
      productGuideCount
      productEventCount
      groupCount
      ownedTierCount
      earningThreshold
      postCount
      createdAt
      ownedGroup {
        id
        slug
        title
        channelCount
        logo {
          original {
            url
          }
        }
        membership {
          id
          newPostsCount
        }
        channels {
          id
          title
          isViewable
        }
        groupTiers {
          id
          name
          description
          group {
            id
            membership {
              id
              groupTier {
                id
              }
              subscription {
                id
                product {
                  id
                  billingFrequency
                  pricingOption {
                    id
                    price
                  }
                }
              }
            }
          }
          unlisted
          yearlyDiscountPercentage
          yearlyDiscountEnabled
          yearlyProductPricingOption {
            id
            price
            supporterOnly
          }
          price {
            currency
            subunits
            value
          }
          hasSetupFee
          setupPrice {
            value
          }
          pricingOption {
            id
          }
          benefits {
            id
            benefitType
            discountPercent
            records {
              ... on API_Product {
                id
              }
            }
          }
          group {
            id
            title
            slug
          }
        }
      }
      groups(first: 1) {
        totalCount
      }
      sessionCancelationPolicy {
        id
        enabled
        amount
        policyType
        timeFrame
        timeUnit
      }
      dailyLimitMinutes {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($input: AccountRefreshTokenInput!) {
    accountRefreshToken(input: $input) {
      result {
        accessToken
        refreshToken
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`;

export const GET_PAYPAL = gql`
  query GetPayPal {
    currentSession {
      id
      paypal {
        id
        email
        createdAt
      }
    }
  }
`;
